import { CAR_CONFIGS as SHARED_CAR_CONFIGS } from '@cars/shared';
import type { CarConfig } from '../types';

const PRESENTATION: Record<number, { textureKey: string; texturePath: string }> = {
  1: { textureKey: 'car-1', texturePath: '/assets/Cars/Car1.png' },
  2: { textureKey: 'car-2', texturePath: '/assets/Cars/Car2.png' },
  3: { textureKey: 'car-3', texturePath: '/assets/Cars/Car3.png' },
};

export const CAR_CONFIGS: Record<number, CarConfig> = Object.fromEntries(
  Object.entries(SHARED_CAR_CONFIGS).map(([id, config]) => [
    id,
    { ...config, ...PRESENTATION[Number(id)] },
  ]),
) as Record<number, CarConfig>;
